<template>
  <div class="newwarp boxsizing miniwarp">
    <div class="auto">
      <page-title title="分享" icon="fa-compass"></page-title>
    </div>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div class="padding-15">
          <dufault-column height="auto" title="用户分享" tooltip="所选时间内用户分享情况及往期对比" v-loading="loading">
            <div slot="bar">
              <dates-picker v-model="hDate" size="mini" style="margin-right:15px;"></dates-picker>
              <el-radio-group v-model="interval" size="mini">
                <el-radio-button :label="item.value" v-for="(item, index) in options" :key="index">{{item.label}}</el-radio-button>
              </el-radio-group>
            </div>
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      分享人数
                      <el-tooltip class="item" effect="dark" content="分享人数" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.share_user || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      分享次数
                      <el-tooltip class="item" effect="dark" content="分享次数" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.share_total || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      分享回流人数
                      <el-tooltip class="item" effect="dark" content="用户通过用户分享的小程序卡片访问的人数" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.back_user || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      分享回流次数
                      <el-tooltip class="item" effect="dark" content="用户通过用户分享的小程序卡片访问的次数" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.back_total || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      分享新增人数
                      <el-tooltip class="item" effect="dark" content="通过用户分享的小程序卡片新增的人数" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.fromopenid_user || 0)}}</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="16">
                  <echarts :data="chartData1" title="" height="270" :nohader="true"></echarts>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column title="分享页面" :nomargin="true" height="auto" v-loading="loading1">
            <div slot="bar">
              <composite-date :tag="tagId" @change="changeTagId"></composite-date>
            </div>
            <div slot="content">
              <el-table :data="totalData1">
                <el-table-column label=" " width="20"></el-table-column>
                <el-table-column prop="name" label="页面">
                  <template slot-scope="scope">
                    {{scope.row.name}}
                  </template>
                </el-table-column>
                <el-table-column prop="user" sortable label="分享人数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="total" sortable label="分享次数" width="120px">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.total)}}
                  </template>
                </el-table-column>
              </el-table>
              <div class="pageBox" v-if="tableData1.length > pageSize">
                <el-pagination
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  @current-change="tablePage1"
                  :current-page.sync="page1"
                  :total="tableData1.length"
                  align="right">
                </el-pagination>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Data as DataModel } from '@/model'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      loading: false,
      hDate: this.util.getDataPickerDefault(),
      interval: 'week',
      options: [
        {
          value: 'day',
          label: '日'
        },
        {
          value: 'week',
          label: '周'
        },
        {
          value: 'month',
          label: '月'
        },
        {
          value: 'quarter',
          label: '季'
        }
      ],
      header: {},
      chartData1: '',
      pageSize: 100,
      hDate1: this.util.getDataPickerDefault(),
      tagId: '7',
      loading1: false,
      tableData1: [],
      totalData1: [],
      page1: 1
    }
  },
  watch: {
    'hDate': function (val) {
      this.getShareSummary()
    },
    'interval': function (val) {
      this.getShareSummary()
    },
    'hDate1': function (val) {
      this.page1 = 1
      this.getShareRout()
    }
  },
  methods: {
    async getShareSummary () {
      this.loading = true
      let res = await DataModel.Miniv2.getShareSummary({
        begin_time: this.hDate[0],
        end_time: this.hDate[1],
        interval: this.interval
      })
      if (!res['err_code']) {
        this.header = res['data'] || {}
        this.chartData1 = DataController.Mini.behaviorShareBarAndLine(this.header['char_list'] || '')
      }
      this.loading = false
    },
    changeTagId (val) {
      this.hDate1 = val
    },
    sortChange1 (column) {
      var tableData1 = this.tableData1
      this.util.arraySort(tableData1, column['prop'], column['order'])
      this.tablePage1(1)
      this.page1 = 1
      this.tableData1 = tableData1
    },
    tablePage1 (val) {
      this.totalData1 = []
      this.tableData1.filter((item, index) => {
        var max = val * this.pageSize
        var min = (val - 1) * this.pageSize
        if (index >= min && index < max) {
          this.totalData1.push(item)
        }
      })
    },
    async getShareRout () {
      this.loading1 = true
      let res = await DataModel.Miniv2.getShareRout({
        begin_time: this.hDate1[0],
        end_time: this.hDate1[1]
      })
      this.loading1 = false
      if (!res['err_code']) {
        this.tableData1 = JSON.parse(JSON.stringify(res['data']))
        this.tablePage1(1)
      }
    }
  },
  created () {
    this.getShareSummary()
    this.getShareRout()
  }
}
</script>

<style scoped>
.useraddbox {
  flex: 1;
}
.useraddbox p {
  font-size: 30px;
  font-weight: 300;
  padding: 20px 0 30px;
}
.nopadbotbox .useraddbox p {
  padding-bottom: 0;
}
</style>
